"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const WeekdaySelector = (props) => {
    const { selectedDays, onChange, mode = 'EDIT', disabled, size, readOnly } = props;
    const readOnlyState = readOnly || mode === 'VIEW' || size === 'xs';
    const weekdays = [
        { label: 'M', value: 'MON' },
        { label: 'T', value: 'TUE' },
        { label: 'W', value: 'WED' },
        { label: 'T', value: 'THU' },
        { label: 'F', value: 'FRI' },
        { label: 'S', value: 'SAT' },
        { label: 'S', value: 'SUN' },
    ];
    const handleClickOnDay = (day) => {
        if (selectedDays && onChange) {
            const result = selectedDays.includes(day)
                ? selectedDays.filter((dayInValue) => dayInValue !== day)
                : [...selectedDays, day];
            onChange(result);
        }
    };
    const dayContent = (day) => {
        const dayClassname = classnames_1.default({
            'holiday': day.value === 'SUN',
            'inner-button': true,
            'weekday-selected': selectedDays === null || selectedDays === void 0 ? void 0 : selectedDays.includes(day.value),
        });
        if (readOnlyState) {
            return (React.createElement("span", { className: dayClassname, key: day.value }, day.label));
        }
        return (React.createElement("button", { type: "button", className: dayClassname, key: day.value, onClick: () => handleClickOnDay(day.value), disabled: disabled }, day.label));
    };
    return (React.createElement("div", { className: classnames_1.default({
            'weekday-selector': true,
            'weekday-selector-xs': size === 'xs',
        }) }, weekdays.map((day) => dayContent(day))));
};
exports.default = WeekdaySelector;
//# sourceMappingURL=WeekdaySelector.js.map